module.exports = __webpack_public_path__ + "icon_reply-b5e28e1fe6acd4ec003e643e947f1c4a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icon_reply.svg
// module id = 266
// module chunks = 86